import { useFeatureFlagEnabled } from 'posthog-js/react';

import { forcesFeatureFlags } from './force-feature-flags.js';

/**
 * Boolean form of the `FeatureFlag` component for data-driven gating (e.g.
 * deciding whether to include a tab in a list). An unknown flag is disabled,
 * in local development as in production, unless {@link forcesFeatureFlags}
 * is set — mirroring `FeatureFlag`.
 *
 * @param flag - The PostHog feature-flag key.
 * @returns Whether the flag is enabled, or `undefined` while PostHog has not
 * yet resolved flags. Callers deciding something destructive from a disabled
 * flag (e.g. rewriting a URL) should treat `undefined` as "not yet known"
 * rather than "off".
 */
export function useFeatureFlag(flag: string): boolean | undefined {
	const isEnabled = useFeatureFlagEnabled(flag);
	return isEnabled ?? (forcesFeatureFlags() ? true : undefined);
}
